import {TabState, TabStateDefaults} from 'Navigation';

export default class ContainerTestOrdersTabState extends TabState {
  override defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Test Orders',
      closeable: false,
      preferenceKey: 'container-test-orders-tab',
    };
  }
}
